import React from 'react';
import axios from 'axios';
import _ from 'lodash';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { MdEdit, MdFileDownload } from 'react-icons/lib/md';

import { API_BASE_URL } from '../../styles/constant';
import { getProductivityList } from '../../services/productivityServices';
import AppShell from '../../components/AppShell';
import Loader from '../../components/Loader';
import DataTable from '../../components/DataTable';
import ModalForm from '../../components/ModalForm';
import CitySelector from '../../components/CitySelector';
import SessionSelector from '../../components/SessionSelector';
import SessionVisualization from '../../components/SessionVisualization';

class Productivity extends React.Component {
  state = {
    dataLoaded: false,
    productivityList: [],
    headers: [],
    error: null,
    tabValue: 0,
    jypCity: 'DELHI',
    session: 'MONSOON',
  };

  dataTableRef = null;

  componentDidMount() {
    this.unsubscribe = getProductivityList((productivityList) => {
      this.setState({ productivityList });
    });

    this.fetchDatatableHeaders();
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  fetchDatatableHeaders = async () => {
    try {
      const {
        data: { data },
      } = await axios.options(`${API_BASE_URL}/datatable/productivity`);
      this.setState({ dataLoaded: true, headers: data || [] });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  };

  getFilteredProductivityList = () => {
    // eslint-disable-next-line max-len
    const productivityForCity = _.filter(this.state.productivityList, { jypCity: this.state.jypCity })[0] || {};
    const productivityForSession = _.toArray(productivityForCity[this.state.session]);
    return _.orderBy(productivityForSession, ['order'], ['asc']);
  };

  renderToolbars = (selectedRows) => {
    if (selectedRows.length === 0) {
      return (
        <ToolbarContainer>
          <CitySelector
            initialValue={this.state.jypCity}
            onChange={(city) => {
              this.setState({ jypCity: city });
            }}
          />
          <SessionSelector
            initialValue={this.state.session}
            onChange={(session) => {
              this.setState({ session });
            }}
          />

          <Tooltip title="Download CSV">
            <IconButton
              aria-label="Download CSV"
              onClick={() => {
                const downloadUrl = `${API_BASE_URL}/productivity/downloadCsv/?city=${
                  this.state.jypCity
                }&session=${this.state.session}`;
                window.open(downloadUrl, '_blank');
              }}
            >
              <MdFileDownload />
            </IconButton>
          </Tooltip>
        </ToolbarContainer>
      );
    }

    return (
      <ToolbarContainer>
        {selectedRows.length === 1 && (
          <ModalForm
            key="edit-attendance"
            tooltipTitle="Edit Productivity"
            trigger={(
              <IconButton aria-label="Edit Productivity">
                <MdEdit size={24} />
              </IconButton>
)}
            apiEndpoint={`${API_BASE_URL}/updateProductivity/?jypCity=${
              this.state.jypCity
            }&session=${this.state.session}&businessType=${selectedRows[0]}`}
            method="put"
            onClose={() => {
              if (this.dataTableRef) {
                this.dataTableRef.resetSelectedRows();
              }
            }}
          />
        )}
      </ToolbarContainer>
    );
  };

  render() {
    return (
      <div>
        <AppShell>
          {this.state.error ? (
            <Typography variant="subheading" color="error">
              {this.state.error}
            </Typography>
          ) : !this.state.dataLoaded ? (
            <Loader />
          ) : (
            <div>
              <TabsContainer>
                <Tabs
                  value={this.state.tabValue}
                  onChange={(event, tabValue) => {
                    this.setState({ tabValue });
                  }}
                >
                  <Tab label="Report" />
                  <Tab label="Visualization" />
                </Tabs>
              </TabsContainer>

              {this.state.tabValue === 0 && (
                <DataTable
                  ref={(comp) => {
                    this.dataTableRef = comp;
                  }}
                  title="Productivity"
                  tableHeaders={this.state.headers}
                  tableData={this.getFilteredProductivityList()}
                  renderToolbars={selectedRows => this.renderToolbars(selectedRows)}
                  disableSearchBar
                />
              )}
              {this.state.tabValue === 1 && (
                <SessionVisualization apiEndPoint={`${API_BASE_URL}/productivity/dashboard`} />
              )}
            </div>
          )}
        </AppShell>
      </div>
    );
  }
}

export default Productivity;

const TabsContainer = styled(Paper).attrs({
  elevation: 4,
})`
  margin-bottom: 16px;

  && {
    background: ${props => props.theme.palette.primary.main};
  }

  & * {
    color: ${props => props.theme.palette.primary.contrastText} !important;
  }
`;

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 10px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Productivity/Productivity.js